import { TimePicker, Form } from 'antd'
import { toDatePickerValue } from '../../../../utils/safeDate.js'


const TimeForm = (props) => {
    const {
        values,
        disabled = false,
        tableLabel = "",
        timeFormat = "HH:mm",
        showSeconds = false,
        use12Hours = false,
        minuteStep = 1,
        hourStep = 1
    } = props

    // Determine the actual format to use based on configuration
    let actualTimeFormat = timeFormat || 'HH:mm';
    if (showSeconds && !actualTimeFormat.includes('ss')) {
        if (use12Hours || actualTimeFormat.includes('A')) {
            actualTimeFormat = 'hh:mm:ss A';
        } else {
            actualTimeFormat = 'HH:mm:ss';
        }
    }

    // Same shape problem as the date column: the stored value may be an ISO
    // string, a bare "HH:mm" string, a live dayjs, or a prototype-less one.
    const currentValue = toDatePickerValue(values?.[props.id], actualTimeFormat)

    if (disabled) {
        return <span>{currentValue ? currentValue.format(actualTimeFormat) : ""}</span>
    }

    return (
        <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
            <TimePicker
                disabled={disabled}
                value={currentValue}
                onChange={(e) => props.handleChange(props.id, e, props.documentId)}
                format={actualTimeFormat}
                use12Hours={use12Hours || actualTimeFormat.includes('A')}
                minuteStep={minuteStep}
                hourStep={hourStep}
                style={{ width: '100%' }}
            />
        </Form.Item>
    )
}

export default TimeForm
